import React from "react";
import { useIntl } from "react-intl";
import { Space, Row, Form } from "@masterteam/mt-design-react";

const { Field } = Form;

function Item({ data = {}, readOnly, onChange, index = 0, name, errors }) {
  const intl = useIntl();
  const generateName = (fieldName) => `${name}[${index}].${fieldName}`;
  const disabledMax = data.MinOperator === "=";

  const lowOperators = [
    {
      label: "<",
      value: "<",
    },
    {
      label: "≤",
      value: "<=",
    },
    {
      label: "=",
      value: "=",
    },
  ];

  const highOperators = [
    {
      label: "<",
      value: "<",
    },
    {
      label: "≤",
      value: "<=",
    },
  ];

  const menuPlacement = index === 0 || index === 1 ? "bottom" : "top";
  return (
    <Row
      size="medium"
      className="kpi-config__form__status-tab__listt-content__item"
    >
      <div
        className="kpi-config__form__status-tab__listt-content__item__column"
        style={{ width: "40%" }}
      >
        <Space className="kpi-config__form__status-tab__names">
          <Field
            name={generateName("EnglishName")}
            inputProps={{ onChange: () => {} }}
            hideLabel
            hideErrorMessage
            disabled
          />
          <Field
            name={generateName("ArabicName")}
            inputProps={{ onChange: () => {} }}
            hideLabel
            hideErrorMessage
            disabled
          />
        </Space>
      </div>
      <div
        className="kpi-config__form__status-tab__listt-content__item__column"
        style={{ width: "11%" }}
      >
        <Field
          name={generateName("Min")}
          type="number"
          disabled={readOnly}
          hideLabel
          hideErrorMessage
          inputProps={{
            error: errors?.Min,
            onKeyDown: (evt) => {
              if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
                evt.preventDefault();
              }
            },
            min: 0,
          }}
        />
      </div>
      <div
        className="kpi-config__form__status-tab__listt-content__item__column"
        style={{ width: "11%" }}
      >
        <div className="select-control">
          <Field
            type="select"
            name={generateName("MinOperator")}
            hideLabel
            hideErrorMessage
            disabled={readOnly}
            inputProps={{
              error: errors?.MinOperator,
              options: lowOperators,
              isClearable: true,
              value:
                lowOperators?.find((e) => e?.value === data?.MinOperator) ||
                null,
              onChange: (e) => {
                onChange(generateName("MinOperator"), e?.value || null);
                if (e.value === "=") {
                  onChange(generateName("MaxOperator"), null);
                  onChange(generateName("Max"), "");
                }
              },
              menuPlacement: menuPlacement,
            }}
          />
        </div>
      </div>
      <Row justify="center" align="center" style={{ width: "10%", height: 40 }}>
        {intl.formatMessage({ id: "common.value" })}
      </Row>
      <div
        className="kpi-config__form__status-tab__listt-content__item__column"
        style={{ width: "11%" }}
      >
        <div className="select-control">
          <Field
            type="select"
            name={generateName("MaxOperator")}
            hideLabel
            hideErrorMessage
            disabled={disabledMax || readOnly}
            inputProps={{
              error: errors?.MaxOperator,
              options: highOperators,
              isClearable: true,
              value:
                highOperators?.find((e) => e?.value === data?.MaxOperator) ||
                null,
              onChange: (e) =>
                onChange(generateName("MaxOperator"), e?.value || null),
              menuPlacement: menuPlacement,
            }}
          />
        </div>
      </div>
      <div
        className="kpi-config__form__status-tab__listt-content__item__column"
        style={{ width: "11%" }}
      >
        <Field
          name={generateName("Max")}
          type="number"
          disabled={disabledMax || readOnly}
          hideLabel
          hideErrorMessage
          inputProps={{
            error: errors?.Max,
            onKeyDown: (evt) => {
              if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
                evt.preventDefault();
              }
            },
            min: 0,
          }}
        />
      </div>
      <div
        className="kpi-config__form__status-tab__listt-content__item__column"
        style={{ width: "11%" }}
      >
        <Space
          align="center"
          className="kpi-config__form__status-tab__listt__color-control"
        >
          <div style={{ color: data?.Color }}>{data?.Color}</div>
          <div
            className="kpi-config__form__status-tab__listt__color-control__color"
            style={{ backgroundColor: data?.Color }}
          />
        </Space>
      </div>
    </Row>
  );
}

export default Item;
